const ActionType = {
  REQUEST: "KANRI_JIGYOSHO_STATUS_REQUEST",
  REQUEST_FINISHED: "KANRI_JIGYOSHO_STATUS_REQUEST_FINISHED",
};

export default ActionType;
